import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { sizeMap, stepClipStyle, stepClipWrapperStaticStyle } from './styles';
function Steps({ id, max, size }) {
    function renderStepRect(index) {
        const width = `${100 / max}%`;
        return (_jsx("rect", { css: stepClipStyle({
                index,
                max,
                size,
            }), rx: parseInt(sizeMap[size].sizing, 10) / 2, width: width }, index));
    }
    return (_jsx("svg", Object.assign({ css: stepClipWrapperStaticStyle }, { children: _jsx("defs", { children: _jsx("clipPath", Object.assign({ id: `${id}-clip` }, { children: Array.from({ length: max }, (_, index) => {
                    return renderStepRect(index);
                }) })) }) })));
}
export default Steps;
